<template>
  <div>
    <nav class="bg-gray-500">
      <div class="container mx-auto">
        <div class="mx-4">
          <div class="flex items-center">
            <div class="w-1/2">
              <p>
                <a
                  href="https://education.nsw.gov.au/early-childhood-education"
                  class="inline md:hidden font-sans font-light text-base leading-normal text-black no-underline"
                >
                  NSW DoE
                  <span class="sr-only">Opens external website</span>
                </a>
                <a
                  href="https://education.nsw.gov.au/early-childhood-education"
                  class="hidden md:inline font-sans font-light text-base leading-normal text-black no-underline"
                >
                  NSW Department of Education
                  <span class="sr-only">Opens external website</span>
                </a>
              </p>
            </div>
            <div class="w-1/2 text-right relative">
              <p class="inline-block" v-if="userName && serviceName">
                <navigation-context
                  class="block md:hidden"
                  icon="user"
                  :more="true"
                  iconSize="small"
                  :actions="filteredActions"
                  :ariaLabel="ariaServiceName"
                  @click="handleSettingsAction($event)"
                />
                <navigation-context
                  class="hidden md:block"
                  :label="`${userName} / ${serviceName}`"
                  :more="true"
                  iconSize="small"
                  :actions="filteredActions"
                  :ariaLabel="ariaServiceName"
                  @click="handleSettingsAction($event)"
                />
              </p>
              <p class="inline-block" v-if="userName && !serviceName">
                <navigation-context
                  class="block md:hidden"
                  icon="user"
                  :more="true"
                  iconSize="small"
                  :actions="[{label: 'Log out',action: 'action:logout',allowFor: ['admin', 'user']}]"
                  :ariaLabel="ariaServiceName"
                  @click="handleSettingsAction($event)"
                />
                <navigation-context
                  class="hidden md:block"
                  :label="`${fullName}`"
                  :more="true"
                  iconSize="small"
                  :actions="[{label: 'Log out',action: 'action:logout',allowFor: ['admin', 'user']}]"
                  :ariaLabel="ariaServiceName"
                  @click="handleSettingsAction($event)"
                />
              </p>
              <p class="inline-block" v-if="!isLoggedIn && !serviceName">
                <button
                  aria-label="Login"
                  @click="handleSettingsAction({ action: 'action:login' })"
                >
                  <span class="prefix">
                    <doe-icon icon="user" size="small" />
                  </span>
                  <span class="pl-1">
                    Login
                  </span>
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <header class="bg-blue-900" role="banner">
      <div class="container mx-auto">
        <div class="mx-4 flex items-center overflow-hidden"  style="max-height: 13rem;">
          <router-link
            :to="{ name: 'landing' }"
            class="font-sans font-light text-white text-4xl md:text-6xl leading-tight no-underline flex-1 py-5"
          >
            {{ headingTitle }}
          </router-link>
          <div class="w-2/5 sm:w-1/3 md:w-1/6">
            <img alt="" src="@/assets/header-banner.png"/>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import handleRoles from "@/mixins/handleRoles";
import NavigationContext from "@/components/navigation/NavigationContext.vue";
import DoeIcon from "@/components/icon/Icon";

export default {
  name: "AppHeader",
  mixins: [handleRoles],
  components: {
    NavigationContext,
    DoeIcon
  },
  data() {
    return {
      tokenRefreshInProgress: false,
      actions: [
        {
          label: "Services",
          action: "action:services",
          allowFor: ["admin", "user"]
        },
        {
          label: "Educators",
          action: "action:users",
          allowFor: ["admin"]
        },
        {
          label: "Log out",
          action: "action:logout",
          allowFor: ["admin", "user"]
        }
      ]
    };
  },
  mounted() {
    this.$root.$on('refreshtoken', () => {
      this.refreshToken()
    })
  },
  watch: {
    profile: {
      handler(val){
        if (Math.floor(Date.now() / 1000) > val.exp) {
          this.terminateSession();
        } else {
          this.watchSession();
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["getService"]),
    filteredActions() {
      return this.actions.filter(action =>
        action.allowFor.includes(this.isCentreDirector ? "admin" : "user")
      );
    },
    headingTitle () {
      return "Self-Assessment and Quality Improvement Planning Portal"
    },
    userName() {
      return this.profile ? `${this.profile.detuserid}` : "";
    },
    serviceName() {
      return this.serviceData.serviceTradingAsName;
    },
    ariaServiceName() {
      return this.profile
        ? `Exit for ${this.profile.givenName} ${this.profile.sn}`
        : "Exit";
    },
    fullName () {
      return `${this.profile.givenName} ${this.profile.sn}`
    }
  },
  methods: {
    ...mapActions(["CLEAR_AUTH", "CLEAR_SERVICE"]),
    watchSession() {
      let timerId = setInterval(() => {
        const currentExpiry = parseInt(localStorage.getItem("token_expiry"));
        if (Math.floor(Date.now() / 1000) > currentExpiry) {
          clearInterval(timerId);
          this.terminateSession();
        }
        if ((+currentExpiry - Math.floor(Date.now() / 1000) < this.$config.VUE_APP_SECONDS_BEFORE_TOKEN_EXPIRY)  ) {
          if (!this.tokenRefreshInProgress) this.renewSession();
        } else {
          //console.log(+currentExpiry - Math.floor(Date.now() / 1000) )
        }
      }, 5000);
    },
    renewSession() {
      this.$root.translateModal(
        "Please click continue to extend the session.",
        "Your session will expire soon",
        {
          withoutCancelBtn: true,
          action: async () => {
            await this.refreshToken();
          }
        }
      );
    },
    async refreshToken() {
      this.tokenRefreshInProgress=true;
      const refreshToken = window.localStorage.getItem('refresh_token');
      if(!refreshToken){
        this.tokenRefreshInProgress=false;
        throw 'No referesh token';
      }
      const data = {
        grant_type: "refresh_token",
        client_id: window.config.VUE_APP_SSOCLIENTID,
        refresh_token: refreshToken
      };
      const body = Object.entries(data).reduce(
        (acc, [key, value], i) => `${acc}${i === 0 ? '' : '&'}${encodeURIComponent(key)}=${encodeURIComponent(value)}`, '',
      );
      const response = await fetch(window.config.VUE_APP_SSOACCESSTOKENURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'Accept': 'application/json'
      },
      body
    });
      if(response.status !== 200){
        this.tokenRefreshInProgress=false;
        throw 'Error in refreshing session';
      }
      const { id_token, access_token, expires_in } = await response.json();
      localStorage.setItem("id_token", id_token);
      localStorage.setItem("access_token", access_token);

      const currentExpiry = localStorage.getItem("token_expiry");
      localStorage.setItem("token_expiry", parseInt(currentExpiry) + expires_in);
      this.$nextTick(
        () => this.$OAuth.setToken(localStorage.getItem('access_token'), localStorage.getItem('id_token'), localStorage.getItem('token_type'), localStorage.getItem('refresh_token'))
      )
      
      this.tokenRefreshInProgress=false;
      return access_token;
    },
    async terminateSession() {
      this.$root.translateModal(
        "Please return to the log in page and enter your user details.",
        "Your session has expired"
      );
      await this.$OAuth.logout();
      this.$router.push({ name: "landing" });
    },
    handleSettingsAction($event) {
      if ($event.action === "action:services") {
        this.$router.push({ name: "service-dashboard" });
      }
      if ($event.action === "action:users") {
        this.$router.push({ name: "user-dashboard" });
      }
      if ($event.action === "action:login") {
        this.$router.push({ name: "service-dashboard" });
      }
      if ($event.action === "action:logout") {
        this.$root.translateModal(
          "To fully end your session, close every browser window AND log off from your user account on this device.",
          "Ready to log out?",
          {
            cancellable: true,
            action: () => {
              this.CLEAR_SERVICE();
              this.CLEAR_AUTH();
              window.location = window.config.portalUrl + '/oauth2/logout'
            }
          }
        );
      }
    }
  }
};
</script>

<style scoped lang="scss">
button {
  @apply cursor-pointer text-blue-900 font-sans font-semibold select-none w-full;
  &:focus {
    outline: 1px solid #041e42;
    outline-offset: 3px;
  }
  svg {
    @apply fill-current;
  }
  @screen md {
    @apply w-auto;
  }
  @apply leading-snug py-2 min-w-sm text-base;
  @apply font-light px-0 min-w-auto;
  height: 44px;
  min-width: 44px;
}
a[href*="//"]:not([href*="localhost.com"]) {
  padding-right: 1.5rem;
  position: relative;
  &:after {
    @apply absolute block;
    content: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 100 89'><path d='M100,4.16666667 L100,26.3861111 C100,30.1119792 95.4930556,31.9381944 92.8869792,29.3324653 L86.6878472,23.1329861 L44.4095486,65.4112847 C42.7822917,67.0385417 40.1442708,67.0385417 38.5170139,65.4112847 L34.5887153,61.4829861 C32.9614583,59.8557292 32.9614583,57.2175347 34.5887153,55.5904514 L76.8673611,13.3118056 L70.6689236,7.11302083 C68.0524306,4.49652778 69.9055556,0 73.6152778,0 L95.8333333,0 C98.1345486,0 100,1.86545139 100,4.16666667 Z M70.6647569,47.0128472 L67.8869792,49.790625 C67.1055707,50.5720468 66.6666073,51.6318913 66.6666667,52.7369792 L66.6666667,77.7777778 L11.1111111,77.7777778 L11.1111111,22.2222222 L56.9444444,22.2222222 C58.049457,22.2221592 59.1092025,21.783211 59.890625,21.0019097 L62.6684028,18.2241319 C65.2932292,15.5991319 63.4342014,11.1111111 59.7222222,11.1111111 L8.33333333,11.1111111 C3.73090278,11.1111111 0,14.8420139 0,19.4444444 L0,80.5555556 C0,85.1579861 3.73090278,88.8888889 8.33333333,88.8888889 L69.4444444,88.8888889 C74.046875,88.8888889 77.7777778,85.1579861 77.7777778,80.5555556 L77.7777778,49.9590278 C77.7777778,46.246875 73.2895833,44.3878472 70.6647569,47.0128472 Z' /></svg>");
    top: 0px;
    right: 0px;
    width: 1.25rem;
    height: 1.25rem;
  }
}
</style>
